<template>
  <div class="am-selectCheck-wrap" :class="classes"
       v-click-outside.capture="onClickOutside"
       v-click-outside:mousedown.capture="onClickOutside"
       v-click-outside:touchstart.capture="onClickOutside"
  >
    <div class="am-selectCheck-selection"
         @click="toggleMenu"
    >
      <template v-if="values.length">
        <span class="am-selectCheck-selected-value" >
          <span v-show="isAllSelect">{{allDesc}}</span>
          <span v-show="!isAllSelect">{{partDesc}}</span>
        </span>
      </template>
      <template v-else>
        <span class="am-selectCheck-placeholder">
          {{placeholder}}
        </span>
      </template>
      <span class="am-selectCheck-arrow"></span>
    </div>
    <transition name="transition-drop">
      <div class="am-selectCheck-dropdown" v-show="dropVisible" :style="dropdownStyle">
        <ul v-show="showNotFoundLabel" :class="['select-not-found']">
          <li>{{ localeNotFoundText }}</li>
        </ul>
        <Checkbox class="am-selectCheck-item" :label="true" :value="isAllSelect" @change="handleAllChange" :class="{'am-selectCheck-item-selected': isAllSelect, 'am-selectCheck-item-focus': isAllSelect}">全选</Checkbox>
        <!--下拉列表-->
        <CheckboxGroup v-model="values" class="am-selectCheck-list" style="margin-top: -1px;">
          <Checkbox class="am-selectCheck-item" v-for="(item) in selectOptions" :label="item.id"  :key="item.id" :class="{'am-selectCheck-item-selected': publicValueObj[item.id], 'am-selectCheck-item-focus': publicValueObj[item.id]}">{{item.label}}</Checkbox>
        </CheckboxGroup>
      </div>
    </transition>
  </div>
</template>

<script>
  import {directive as clickOutside} from 'v-click-outside-x';
  import CheckboxGroup from '../CheckboxGroup';
  import Checkbox from '../Checkbox';
  const prefixCls = 'am-selectCheck';
  const checkValuesNotEqual = (value, publicValue, values) => {
    const strValue = JSON.stringify(value);
    const strPublic = JSON.stringify(publicValue);
    const strValues = JSON.stringify(values.map(item => {
      return item
    }));
    return strValue !== strPublic || strValue !== strValues || strValues !== strPublic;
  };
  export default {
    name: 'am-selectCheck',
    props: {
      value: {
        type: [String, Number, Array]
      },
      disabled: {
        type: Boolean,
        default: false
      },
      selectOptions: {
        type: Array,
        default: function () {
          return []
        }
      },
      // 显示文本
      placeholder: {
        type: [String, Number],
        default: '请选择'
      },
      // 全部描述
      allDesc: {
        type: [String, Number],
        default: '全部'
      },
      // 部分描述
      partDesc: {
        type: [String, Number],
        default: '部分'
      }
    },
    directives: {clickOutside},
    created() {
    },
    data() {
      return {
        values: this.getInitialValue(),
        visible: false,
        dropDownWidth: 0,
        localeNotFoundText: '无匹配数据',
        multiple: true
      }
    },
    watch: {
      value(value) {
        const {getInitialValue, publicValue, values} = this;
        if (value === '' || value === null) {
          this.values = [];
        }
        else if (checkValuesNotEqual(value, publicValue, values)) {
          this.values = getInitialValue()
        }
      },
      values(now, before) {
        const newValue = JSON.stringify(now);
        const oldValue = JSON.stringify(before);
        const vModelValue = this.multiple ? this.publicValue.map((value) => value) : this.publicValue;
        const vModelItem = this.multiple ? this.publicItem.map(value => value) : this.publicItem[0];
        const shouldEmitInput = newValue !== oldValue;
        if (shouldEmitInput) {
          this.$emit('input', vModelValue);
          this.$emit('on-change', vModelItem);
        }
      }
    },
    mounted() {
      this.checkUpdateStatus();
    },
    computed: {
      classes() {
        return [
          {
            [`${prefixCls}-multiple`]: this.multiple,
            [`${prefixCls}-single`]: !this.multiple,
            [`${prefixCls}-disabled`]: this.disabled,
          }
        ]
      },
      dropVisible() {
        let status = true;
        const noOptions = !this.selectOptions || this.selectOptions.length === 0;
        if (noOptions || (!this.loading && this.remote && this.query === '' && noOptions)) status = false;
        return this.visible && status;
      },
      dropdownStyle() {
        if (this.dropVisible) return {
          minWidth: this.dropDownWidth + 'px',
          position: 'absolute',
          willChange: 'top, left',
          transformOrigin: 'center top'
        };
        else return {}
      },
      publicValueObj() {
        let o = {};
        this.values.forEach(value => {
          if (value) o[value] = true
        });
        return o;
      },
      publicValue() {
        return this.multiple ? this.values : this.values[0];
      },
      publicItem() {
        let {publicValueObj, selectOptions} = this,
          labels = [];
        selectOptions.forEach(value => {
          if (publicValueObj[value.id]) {
            labels.push(value)
          }
        });
        return labels
      },
      isAllSelect () {
        let selectOptions = this.selectOptions,
            values = this.values,
            isTrue = selectOptions.length === values.length;
        return isTrue
      },
      showNotFoundLabel() {
        const {selectOptions} = this;
        return selectOptions && selectOptions.length === 0;
      },
      allOptionId () {
        let values = [];
        this.selectOptions.forEach((item) => {
          values.push(item.id)
        });
        return values
      }
    },
    methods: {
      handleAllChange (isAll) {
        let values = [];
        if (isAll) {
          values.push(...this.allOptionId)
        }
        this.values = values
      },
      toggleMenu(e, force) {
        if (this.disabled) {
          return false;
        }
        this.visible = typeof force !== 'undefined' ? force : !this.visible;
        if (this.visible) {
          this.dropDownWidth = this.$el.getBoundingClientRect().width;
        }
      },
      hideMenu() {
        this.toggleMenu(null, false);
      },
      onClickOutside(event) {
        if (this.visible) {
          if (event.type === 'mousedown') {
            event.preventDefault();
            return;
          }
          this.hideMenu();
          event.preventDefault();
        }
      },
      getInitialValue() {
        const {multiple, value} = this;
        let initialValue = Array.isArray(value) ? value : [value];
        if (!multiple && (typeof initialValue[0] === 'undefined'|| initialValue[0] === null || (String(initialValue[0]).trim() === '' && !Number.isFinite(initialValue[0])))) initialValue = [];
        return initialValue
      },
      checkUpdateStatus() {
        if (this.getInitialValue().length > 0 && this.selectOptions.length === 0) {
          this.hasExpectedValue = true;
        }
      }
    },
    destroyed() {
    },
    components: {
      CheckboxGroup,
      Checkbox
    }
  }
</script>

<style lang="scss">
  $css-select: 'am-selectCheck';
  @mixin arrow {
    width: 0;
    height: 0;
    font-size: 0;
    line-height: 0;
    display: block;
    position: absolute;
    border: 5px solid transparent;
    border-style: dashed dashed solid;
  }

  ;
  @mixin selectItemValue {
    display: block;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 8px;
    padding-right: 24px;
  }

  .#{$css-select}-wrap {
    display: inline-block;
    width: 100%;
    box-sizing: border-box;
    vertical-align: middle;
    color: #515a6e;
    font-size: 14px;
    line-height: normal;
    width: 200px;
    .#{$css-select}-arrow {
      position: absolute;
      top: 50%;
      right: 8px;
      width: 10px;
      height: 10px;
      &:before {
        content: '';
        @include arrow();
        border-top-color: #808695;
        bottom: 0px;
      }
      &:after {
        content: '';
        @include arrow();
        border-top-color: #fff;
        bottom: 1px;
      }
    }
    .#{$css-select}-selection {
      display: block;
      box-sizing: border-box;
      outline: 0;
      user-select: none;
      cursor: pointer;
      position: relative;
      background-color: #fff;
      border-radius: 4px;
      border: 1px solid #dcdee2;
      transition: all .2s ease-in-out;
      &:hover {
        border-color: #57a3f3;
      }
      .#{$css-select}-placeholder {
        @include selectItemValue()
      }
    }
    .#{$css-select}-dropdown {
      width: inherit;
      max-height: 200px;
      overflow: auto;
      margin: 5px 0;
      padding: 5px 0;
      background-color: #fff;
      box-sizing: border-box;
      border-radius: 4px;
      box-shadow: 0 1px 6px rgba(0, 0, 0, .2);
      position: absolute;
      z-index: 900;
    }
    ul {
      padding-left: 0 !important;
      list-style-type: none;
    }
    .#{$css-select}-not-found, .#{$css-select}-loading {
      text-align: center;
      color: #c5c8ce;
      li {
        margin-bottom: 0;
      }
    }
    .#{$css-select}-dropdown-list {
      min-width: 100%;
      list-style: none;
    }
    .#{$css-select}-item {
      margin: 0;
      line-height: normal;
      padding: 7px 16px;
      clear: both;
      color: #515a6e;
      font-size: 12px !important;
      white-space: nowrap;
      list-style: none;
      cursor: pointer;
      transition: background .2s ease-in-out;
      width: 100%;
    }
    .#{$css-select}-item-selected, .#{$css-select}-item-selected:hover {
      color: #2d8cf0;
    }
    .#{$css-select}-item-focus, .#{$css-select}-item:hover {
      background: #f3f3f3;
    }
  }

  ;
  .#{$css-select}-single, .#{$css-select}-multiple{
    .#{$css-select}-selection {
      height: 32px;
      position: relative;
      .#{$css-select}-selected-value {
        @include selectItemValue()
      }
    }
  }

  ;
  .#{$css-select}-input {
    display: inline-block;
    height: 32px;
    line-height: 32px;
    padding: 0 24px 0 8px;
    font-size: 12px;
    outline: 0;
    border: none;
    box-sizing: border-box;
    color: #515a6e;
    background-color: transparent;
    position: relative;
    cursor: pointer;
    width: 100%;
  }

  .transition-drop-appear,
  .transition-drop-enter-active {
    -webkit-animation-duration: .3s;
    animation-duration: .3s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    -webkit-animation-play-state: paused;
    animation-play-state: paused
  }

  .transition-drop-leave-active {
    -webkit-animation-duration: .3s;
    animation-duration: .3s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    -webkit-animation-play-state: paused;
    animation-play-state: paused
  }

  .transition-drop-appear,
  .transition-drop-enter-active {
    -webkit-animation-name: TransitionDropIn;
    animation-name: TransitionDropIn;
    -webkit-animation-play-state: running;
    animation-play-state: running
  }

  .transition-drop-leave-active {
    -webkit-animation-name: TransitionDropOut;
    animation-name: TransitionDropOut;
    -webkit-animation-play-state: running;
    animation-play-state: running
  }

  .transition-drop-appear, .transition-drop-enter-active {
    opacity: 0;
    -webkit-animation-timing-function: ease-in-out;
    animation-timing-function: ease-in-out
  }

  .transition-drop-leave-active {
    -webkit-animation-timing-function: ease-in-out;
    animation-timing-function: ease-in-out
  }

  @keyframes TransitionDropIn {
    0% {
      opacity: 0;
      -webkit-transform: scaleY(.8);
      transform: scaleY(.8)
    }
    100% {
      opacity: 1;
      -webkit-transform: scaleY(1);
      transform: scaleY(1)
    }
  }

  @keyframes TransitionDropOut {
    0% {
      opacity: 1;
      -webkit-transform: scaleY(1);
      transform: scaleY(1)
    }
    100% {
      opacity: 0;
      -webkit-transform: scaleY(.8);
      transform: scaleY(.8)
    }
  }
</style>



// WEBPACK FOOTER //
// components/Cc-SelectCheck/Cc-SelectCheck.vue